const AgentReportUICardComponent = (props) => {

    const {
        title,
        headerValue,
        leftLabel,
        leftValue,
        isLeftInnerHTML,
        rightLabel,
        rightValue,
        isRightInnerHTML,
    } = props

    return (
        <div class="progess-rpeort-content agent-learning-points">
            <div class="proglefttext">{title}</div>
            <div class="prgcounttext">
                {/* <p dangerouslySetInnerHTML={{
                __html: overAllLearningPoints?.learning_hrs_val,
            }}></p> */}
                {headerValue}
            </div>
            <div className="d-flex gap-4 justify-content-center mt-3">
                <div className="count-col">
                    {/* <div className="coluns-report-rsp">
                        {
                            isLeftInnerHTML ?
                            <p dangerouslySetInnerHTML={{
                                __html: leftValue,
                            }}></p> :
                           Number(leftValue) >= 0 ? "+" + leftValue + "%" : leftValue + "%"
                        }
                        
                    </div>
                    <div className="complints-sub-text">
                        {leftLabel}
                    </div> */}
                     <div class={Number(leftValue) < 0 ? "coluns-report-rsp-percent minus-percent" : "coluns-report-rsp-percent"} >
                        {Number(leftValue) >= 0 ? "+" + leftValue + "%" : leftValue + "%"}<small></small>
                    </div>
                    <div className="complints-sub-text">
                        {leftLabel}
                    </div>
                </div>
                <div className="count-col">
                    <div class={Number(rightValue) < 0 ? "coluns-report-rsp-percent minus-percent" : "coluns-report-rsp-percent"} >
                        {Number(rightValue) >= 0 ? "+" + rightValue + "%" : rightValue + "%"}<small></small>
                    </div>
                    <div className="complints-sub-text">
                        {rightLabel}
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default AgentReportUICardComponent